import { IList } from 'annotation-tools/utils';
import { FetchErrorType } from '../../../../types/common/fetch-error-type';
import {
  RawDetailErrorType,
  RawNonFieldErrorsType
} from './types/common-error-type';

export const defaultErrorResponseConverter = (
  body: RawDetailErrorType | RawNonFieldErrorsType
): FetchErrorType<void> => {
  if ('detail' in body) {
    if (Object.keys(body).length !== 1) {
      // bodyに.detail以外のメンバーが存在するとき
      throw new Error(
        'there are some property other than "detail" for `detail` error type'
      );
    }
    return {
      type: 'detail',
      content: body.detail
    };
  }

  return { type: 'others' };
};

/**
 * @description
 * validation error 用の converter を受け取り，
 * 《response body を FetchErrorType に変換する関数》を返す関数
 */
export const errorResponseConverterGenerator = <
  RawValidationErrorResponseBody,
  ValidationErrorResponseBody
>(
  validationErrorConverter: (
    _value: RawValidationErrorResponseBody
  ) => ValidationErrorResponseBody
) => (
  body:
    | RawValidationErrorResponseBody
    | RawDetailErrorType
    | RawNonFieldErrorsType
): FetchErrorType<ValidationErrorResponseBody> => {
  if ('detail' in body) {
    if (Object.keys(body).length !== 1) {
      // bodyに.detail以外のメンバーが存在するとき
      throw new Error(
        'there are some property other than "detail" for `detail` error type'
      );
    }
    return {
      type: 'detail',
      content: body.detail
    };
  }

  if ('non_field_errors' in body) {
    if (Object.keys(body).length !== 1) {
      // bodyに.non_field_errors 以外のメンバーが存在するとき
      throw new Error(
        'there are some property other than "non_field_errors" for "non-field-errors" error type'
      );
    }
    return {
      type: 'non-field-errors',
      content: IList<string>(body.non_field_errors)
    };
  }

  if (validationErrorConverter !== undefined) {
    return {
      type: 'validation-error',
      content: validationErrorConverter(body)
    };
  }

  return { type: 'others' };
};
